import { MarketingView } from '../views';
export default MarketingView;
